import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/anime';

export default function LatestSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">持续更新的动漫追番列表</p>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            全部列表 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {latestUpdates.map((anime) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={anime.coverUrl}
                  alt={anime.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={`${anime.title} - 樱花动漫之家`}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 text-xs font-medium">
                    {anime.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <p className="text-background-50 text-xs">{anime.episode}</p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                {anime.tags.slice(0, 2).map((tag) => (
                  <span key={tag} className="text-xs text-foreground-500">{tag}</span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}